import { 
    statementOption,
    editStatementPage
    } from "@/apis/company/landlordReport.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_landlord_report_obj: 'newLandlordReport/set_landlord_report_obj',
    set_filter_query: 'newLandlordReport/set_filter_query',
    set_filter_word: 'newLandlordReport/set_filter_word',
    set_filter_default: 'newLandlordReport/set_filter_default',
}

// count state 必須是 Object
const state = {
    landlordReportObj: {},
    filterQuery: {
        status: null,
        date: [],
        type: null,
        item: null,
        ledgerZero: false,
        billZero: false,
    },
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_NEW_LANDLORD_REPORT: (state) => {
        return state.landlordReportObj
    },
    GET_BIZ_NEW_LANDLORD_REPORT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_NEW_LANDLORD_REPORT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_NEW_LANDLORD_REPORT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizNewLandlordReport ( {commit, state}, data) {
        return new Promise((resolve, reject) => {
            statementOption(data)
            .then(res => {
                console.log('getBizNewLandlordReport',res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    commit(types.set_landlord_report_obj, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    getBizEditLandlordReport ( {commit, state}, params) {
        return new Promise((resolve, reject) => {
            editStatementPage(params)
            .then(res => {
                console.log('getBizEditLandlordReport',res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    commit(types.set_landlord_report_obj, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizNewLandlordReportFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setBizNewLandlordReportFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizNewLandlordReportFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            let filter = {
                status: null,
                date: [],
                type: null,
                item: null,
                ledgerZero: false,
                billZero: false,
            }
            commit(types.set_filter_default, filter);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_landlord_report_obj](state, data){
        state.landlordReportObj = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_default](state, data){
        state.filterQuery = data
        state.filterWord = ''
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/financialReport/newLandlordReport.js